// extracted by mini-css-extract-plugin
module.exports = {"dialogContentWrapper":"DialogAddItem_dialogContentWrapper__uG-VE"};